import React from 'react';
import { useNavigate } from 'react-router-dom';

const SubscriptionCancelPage = () => {
	const navigate = useNavigate();

	const handleGoBack = () => {
		navigate('/subscription');
	};

	const handleGoToDashboard = () => {
		navigate('/dashboard');
	};

	return (
		<div className="flex min-h-screen items-center justify-center bg-gray-50 px-4">
			<div className="w-full max-w-md rounded-lg bg-white p-8 shadow-lg">
				{/* Info Icon */}
				<div className="mb-4 flex justify-center">
					<div className="flex h-16 w-16 items-center justify-center rounded-full bg-yellow-100">
						<svg
							className="h-8 w-8 text-yellow-600"
							fill="none"
							stroke="currentColor"
							viewBox="0 0 24 24"
						>
							<path
								strokeLinecap="round"
								strokeLinejoin="round"
								strokeWidth={2}
								d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
							/>
						</svg>
					</div>
				</div>

				{/* Message */}
				<div className="mb-6 text-center">
					<h1 className="mb-2 text-2xl font-bold text-gray-900">
						Checkout Canceled
					</h1>
					<p className="text-gray-600">
						Your subscription checkout was canceled. No charges were made. You can
						try again anytime.
					</p>
				</div>

				{/* Action Buttons */}
				<div className="space-y-3">
					<button
						onClick={handleGoBack}
						className="w-full rounded-lg bg-blue-600 px-4 py-2 font-semibold text-white hover:bg-blue-700"
					>
						Back to Plans
					</button>
					<button
						onClick={handleGoToDashboard}
						className="w-full rounded-lg border border-gray-300 bg-white px-4 py-2 font-semibold text-gray-700 hover:bg-gray-50"
					>
						Go to Dashboard
					</button>
				</div>
			</div>
		</div>
	);
};

export default SubscriptionCancelPage;

